import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { FAILURE, REQUEST, SUCCESS } from 'Stores'
import { MESSAGE_WEEKLY } from 'Modules/userList/weekly/constants'
import { getPortFolioWithId } from 'APIs/portfolio.api'
import { createFolder, deleteFile, deleteFolder, getDownloadUrlFolder, getListItemById, moveFile, moveFolder, renameFile, renameFolder, uploadFile } from 'APIs/weeklyAndHeadcount.api'
import { CHANGE_NAME,
  CREATE_FOLDER,
  DELETE_FILE,
  GET_BREAD,
  GET_DRIVES_HOT_LOAD,
  GET_FILES_T0_DOWNLOAD_FOLDER,
  GET_ONE_DRIVE, GET_ONE_DRIVE_AND_BREAD, GET_ONE_DRIVE_FOLDER_MOVE,
  GET_PORTFOLIO,
  MOVE_ITEM,
  UPLOAD_FILE,
  UPLOAD_FOLDER
} from './constants'

function getBreadScum(arr, breadNow) {
  const listScrum = []
  if (arr && arr?.length > 1) {
    for (let i = 1; i < arr?.length; i += 1) {
      listScrum.push({
        key: arr[i].id,
        text: arr[i].name
      })
    }
  }
  listScrum.push(breadNow)
  return listScrum
}

function isTypeFolder(type) {
  if (type === 'folder') { return true }
  return false
}

export function* getListOneDrive({ payload }) {
  try {
    yield put(showOverlay())
    const { idFolder, isListMove, topLoad } = payload
    const data = yield call(getListItemById, {
      idFolder,
      topLoad
    })
    if (isListMove) {
      yield put({
        type: SUCCESS(GET_ONE_DRIVE_FOLDER_MOVE),
        payload: {
          listFolderMove: data.result.children,
          idParentMove: data.result.parent.id
        }
      })
    } else {
      yield put({
        type: SUCCESS(GET_ONE_DRIVE),
        payload: {
          listOneDrive: data.result.children,
          topLoad
        }
      })
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ONE_DRIVE),
      error
    })
    yield put(hideOverlay())
  }
}

export function* getListOneDriveAndBreadSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { idFolder, search, isListMove, topLoad } = payload
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    if (isListMove) {
      yield put({
        type: SUCCESS(GET_ONE_DRIVE_FOLDER_MOVE),
        payload: {
          listFolderMove: data.result.children
        }
      })
    } else {
      yield put({
        type: SUCCESS(GET_ONE_DRIVE),
        payload: {
          listOneDrive: data.result.children,
          topLoad
        }
      })
    }
    yield put({
      type: SUCCESS(GET_BREAD),
      payload: getBreadScum(data.result.parents, {
        text: data.result.name,
        key: data.result.id
      })
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ONE_DRIVE),
      error
    })
    yield put(hideOverlay())
  }
}

export function* getDrivesHotLoadSaga({ payload, callback }) {
  try {
    const { idFolder, search, topLoad } = payload
    yield callback(true)
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_DRIVES_HOT_LOAD),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield callback(false)
  } catch (error) {
    yield callback(false)
    yield put(showModalMessage({ message: error }))
  }
}

export function* deleteItemOneDrive({ payload }) {
  try {
    const { idFolder, id, search, topLoad, type } = payload
    yield put(showOverlay())
    if (isTypeFolder(type)) {
      yield call(deleteFolder, {
        id
      })
    } else {
      yield call(deleteFile, {
        id
      })
    }
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.DELETE_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* changeNameOneDrive({ payload }) {
  try {
    const { userId, idFolder, idItem, name, search, topLoad, type } = payload
    yield put(showOverlay())
    if (isTypeFolder(type)) {
      yield call(renameFolder, {
        userId,
        idItem,
        name
      })
    } else {
      yield call(renameFile, {
        userId,
        idItem,
        name
      })
    }
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.CHANGE_NAME_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* createFolderOneDrive({ payload }) {
  try {
    const { userId, idFolder, name, search, topLoad, portfolioId } = payload
    yield put(showOverlay())
    yield call(createFolder, {
      parentId: idFolder,
      name,
      portfolioId,
      userId
    })
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.CREATE_FOLDER_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* moveItemOneDrive({ payload }) {
  try {
    const { userId, idFolder, idFolderToMove, idItem, topLoad, search, type } = payload
    yield put(showOverlay())
    if (isTypeFolder(type)) {
      yield call(moveFolder, {
        userId,
        parentId: idFolderToMove,
        idItem
      })
    } else {
      yield call(moveFile, {
        userId,
        folderId: idFolderToMove,
        idItem
      })
    }

    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.MOVE_FOLDER_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* uploadFileOneDrive({ payload }) {
  try {
    const { userId, idFolder, infoUploadFile, idPortfolio, search, topLoad } = payload
    yield put(showOverlay())
    const formData = new FormData()
    formData.append('folder_id', idFolder)
    formData.append('user_id', userId)
    formData.append('portfolio_id', idPortfolio)
    formData.append('file', infoUploadFile.data, infoUploadFile.name)
    yield call(uploadFile, formData)
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.UPLOAD_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* getPortfolioSaga({ payload }) {
  try {
    // yield put(showOverlay())
    const { result } = yield call(getPortFolioWithId, payload)
    yield put({
      type: SUCCESS(GET_PORTFOLIO),
      payload: result
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
  }
}

export function* getFilesToDownloadFolderSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { idFolder } = payload
    const data = yield call(getDownloadUrlFolder, {
      idFolder
    })
    if (data.result?.length === 0) {
      yield put(showModalMessage({ message: MESSAGE_WEEKLY.FOLDER_EMPTY }))
    } else {
      yield put({
        type: SUCCESS(GET_FILES_T0_DOWNLOAD_FOLDER),
        payload: {
          listFilesToDownload: data.result
        }
      })
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* uploadFolderSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { userId, idFolder, name, portfolioId, search, topLoad, listFileUpload } = payload
    const dataFolder = yield call(createFolder, {
      userId,
      parentId: idFolder,
      name,
      portfolioId
    })
    // eslint-disable-next-line consistent-return, array-callback-return
    yield all(listFileUpload.map((dataFile) => {
      if (dataFile) {
        const formData = new FormData()
        formData.append('folder_id', dataFolder.result.id)
        formData.append('user_id', userId)
        formData.append('portfolio_id', portfolioId)
        formData.append('file', dataFile.data, dataFile.name)
        return call(uploadFile, formData)
      }
    }))
    const data = yield call(getListItemById, {
      idFolder,
      search,
      topLoad
    })
    yield put({
      type: SUCCESS(GET_ONE_DRIVE),
      payload: {
        listOneDrive: data.result.children,
        topLoad
      }
    })
    yield put(showModalMessage({ message: MESSAGE_WEEKLY.UPLOAD_SUCCESS, type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export default function* authSaga() {
  yield takeLatest(REQUEST(GET_ONE_DRIVE), getListOneDrive)
  yield takeLatest(REQUEST(GET_ONE_DRIVE_AND_BREAD), getListOneDriveAndBreadSaga)
  yield takeLatest(REQUEST(DELETE_FILE), deleteItemOneDrive)
  yield takeLatest(REQUEST(CHANGE_NAME), changeNameOneDrive)
  yield takeLatest(REQUEST(CREATE_FOLDER), createFolderOneDrive)
  yield takeLatest(REQUEST(MOVE_ITEM), moveItemOneDrive)
  yield takeLatest(REQUEST(UPLOAD_FILE), uploadFileOneDrive)
  yield takeLatest(REQUEST(GET_DRIVES_HOT_LOAD), getDrivesHotLoadSaga)
  yield takeLatest(REQUEST(GET_PORTFOLIO), getPortfolioSaga)
  yield takeLatest(REQUEST(GET_FILES_T0_DOWNLOAD_FOLDER), getFilesToDownloadFolderSaga)
  yield takeLatest(REQUEST(UPLOAD_FOLDER), uploadFolderSaga)
}
